export default function decimals(num, digits = 1) {
  return parseFloat(num + '').toFixed(digits)
}
